import React, { useState, useEffect } from "react";
import Character from "../components/Character";
import Grid from "@mui/material/Grid";
import Search from "../components/Search";
import { LoopCircleLoading } from "react-loadingg";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";

const CharacterList = () => {
  const [characters, setCharacters] = useState([]);
  const [error, setError] = useState(null);
  const [isLoaded, setIsLoaded] = useState(false);
  const [filteredCharacters, setFilteredCharacters] = useState([]);

  const [type, setType] = React.useState("");
  const [rarity, setRarity] = React.useState("");
  const [clas, setClas] = React.useState("");

  const handleChangeClas = (e) => {
    setRarity("All");
    setType("All");
    setClas(e.target.value);
    if (e.target.value === "All") {
      setFilteredCharacters(characters);
    } else {
      const filtered = characters.filter(
        (item) => item.clas.name === e.target.value
      );

      setFilteredCharacters(filtered);
    }
  };

  const handleChangeType = (e) => {
    setClas("All");
    setRarity("All");
    setType(e.target.value);
    if (e.target.value === "All") {
      setFilteredCharacters(characters);
    } else {
      const filtered = characters.filter(
        (item) => item.type.name === e.target.value
      );

      setFilteredCharacters(filtered);
    }
  };

  const handleChangeRarity = (e) => {
    setType("All");
    setClas("All");
    setRarity(e.target.value);
    if (e.target.value === "All") {
      setFilteredCharacters(characters);
    } else {
      const filtered = characters.filter(
        (item) => item.rarity.name === e.target.value
      );

      setFilteredCharacters(filtered);
    }
  };

  useEffect(() => {
    fetch("https://revived-witch-api.herokuapp.com/api/characters")
      .then((res) => res.json())
      .then(
        (result) => {
          setIsLoaded(true);

          setCharacters(result.characters);
          setFilteredCharacters(result.characters);
        },
        (error) => {
          setIsLoaded(true);
          setError(error);
        }
      );
  }, []);

  if (error) {
    return <>{error.message}</>;
  } else if (!isLoaded) {
    return  <div style={{height: "100vh", weight:"50%"}}><LoopCircleLoading /></div>;
  } else {
    return (
      <>
        <Grid container spacing={2} style={{ marginTop: "20px" }}>
          <Grid item xs={12} md={12} style={{ marginBottom: "30px" }}>
            <Search data={characters} />
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={4} md={4}  style={{ marginBottom: "30px" }}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Class</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={clas}
                label="Class"
                onChange={(e) => handleChangeClas(e)}
              >
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="Assassin">Assassin</MenuItem>
                <MenuItem value="Compeller">Compeller</MenuItem>
                <MenuItem value="Mage">Mage</MenuItem>
                <MenuItem value="Destroyer">Destroyer</MenuItem>
                <MenuItem value="Guardian">Guardian</MenuItem>
                <MenuItem value="Healer">Healer</MenuItem>
                <MenuItem value="Witch">Witch</MenuItem>
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={4} md={4} style={{ marginBottom: "30px" }}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Type</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={type}
                label="Type"
                onChange={(e) => handleChangeType(e)}
              >
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="Brimstone">Brimstone</MenuItem>
                <MenuItem value="Mercury">Mercury</MenuItem>
                <MenuItem value="Saltstone">Saltstone</MenuItem>
                <MenuItem value="Aether">Aether</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item xs={4} md={4} style={{ marginBottom: "30px" }}>
            <FormControl fullWidth>
              <InputLabel id="demo-simple-select-label">Rarity</InputLabel>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={rarity}
                label="Rarity"
                onChange={(e) => handleChangeRarity(e)}
              >
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="UR">UR</MenuItem>
                <MenuItem value="SSR">SSR</MenuItem>
                <MenuItem value="SR">SR</MenuItem>
                <MenuItem value="R">R</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>

        <Grid container spacing={1} style={{ marginBottom: 30 }}>
          {filteredCharacters.map((char, index) => (
            <>
              <Grid item xs={6} md={2} sm={4} style={{ display: "flex" }} key={index}>
                <Character key={char._id} data={char} />
              </Grid>
            </>
          ))}
        </Grid>
      </>
    );
  }
};

export default CharacterList;
